<template>
  <div class="seat-wrapper">
    <v-card class="seat-plan-card">
      <img 
        :src="seatPlanImagePath"
        ref="seatImage"
        class="seat-image" 
        @load="getImageSize" />
      <v-btn
        :style="getSeat()"
        :disabled="true"
        class="seat-btn"
      ></v-btn>
    </v-card>
  </div>
</template>

<script>

export default {

  data() {
    return {
    originalImageSize: {
        width: 1,
        height: 1
      },
    }
  },

  props: {
    seatPlanLocation: {
      type: String,
      required: false
    },
    seatPlanImagePath: {
      type: String,
      required: true
    },
    seatPlanSeatYpos: {
      type: Number,
      required: false
    },
    seatPlanSeatXpos: {
      type: Number,
      required: false
    }
  },

  methods: {
    getImageSize() {
      const img = this.$refs.seatImage;
      this.originalImageSize.width = img.naturalWidth;
      this.originalImageSize.height = img.naturalHeight;
    },

    getSeat() {
      const xPercent = (this.seatPlanSeatXpos / this.originalImageSize.width) * 100;
      const yPercent = (this.seatPlanSeatYpos / this.originalImageSize.height) * 100;

      return {
        position: 'absolute',
        top: yPercent + '%',
        left: xPercent + '%',
        transform: 'translate(-50%, -50%)'
      };
    },

  }
}

</script>

<style scoped>

.seatplan-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  margin: 1%;
  border-radius: 4px;
}

.seat-plan-card {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
}

.seat-image {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
  display: block;
}

:deep(.v-theme--dark) .seat-image {
  filter: 
    invert(1)
    hue-rotate(180deg)
    brightness(0.9)
    contrast(0.75)
    saturate(0.75);
}
.seat-btn {
  position: absolute;
  background-color: #0099ff41;
  width: 2vw !important;
  aspect-ratio: 1 / 1 !important;
  min-width: 0 !important;
  min-height: 0 !important;
  height: auto !important;
  padding: 0 !important;
  z-index: 10;
}
</style>